import type { DefinedWebView } from '@/api';
import { defineStore } from 'pinia';

export const useContextStore = defineStore('context', () => {
    const definedWebViews = shallowRef<DefinedWebView[]>();
    const isInitialized = ref(false);

    const init = async () => {
        const result = await refreshContext();
        isInitialized.value = true;
        return result;
    };

    const refreshDefinedWebViews = async () => {
        definedWebViews.value = [];
        // try {
        //     const { data } = await api.listDefinedWebViews();
        //     definedWebViews.value = data;
        // } catch (e) {
        //     definedWebViews.value = undefined;
        //     console.error('Failed to refresh defined web views', e);
        // }
    };

    const refreshContext = async () => {
        await Promise.all([refreshDefinedWebViews()]);
    };

    return {
        init,
        isInitialized,
        definedWebViews,
        refreshDefinedWebViews,
        refreshContext,
    };
});
